import type { JSX, PropsWithChildren } from 'react'

/**
 * The fields sit side by side from the left, constrained to the same width as
 * View.Content, so they start at the left edge of the article text. Wraps when
 * both fields do not fit, so the content source drops below the byline instead
 * of being pushed out of a narrow view.
 */
export const MetaBarRow = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <div className='flex flex-row flex-wrap items-start gap-2 w-full max-w-[1000px] mx-auto px-4 pt-2'>
      {children}
    </div>
  )
}
